
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBeaconMinorSafeWater as ObiSimplifiedBeaconMinorSafeWaterElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-beacon-minor-safe-water.js';
 
 
 

 
 export const ObiSimplifiedBeaconMinorSafeWater = createComponent({
   react: React,
   tagName: 'obi-simplified-beacon-minor-safe-water',
   elementClass: ObiSimplifiedBeaconMinorSafeWaterElement,
   events: {
     
   }
  });
 
 